import { Components } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "styled-components";
import { CenterPanelContext } from "../..";
import NewsFeedEmptyGorilla from "../../../../../../svg/NewsFeed-Empty-Gorilla.svg";
import { ROUTES } from "../../../../../../utills/routes";
import {
  BackgroundContainer,
  BorderContainer,
  Container,
  EmptyContainer,
  IconContainer,
  InfoContainer,
  NotPostedContainer,
  SelectedCircleContainer,
  Wrapper,
} from "./style";

const NewsFeedEmpty = () => {
  const navigate = useNavigate();
  const { Color, typography } = useTheme();
  const { selectedCircle } = useContext(CenterPanelContext);

  const isMultipleCircle = selectedCircle.length > 1;

  return (
    <EmptyContainer>
      <BorderContainer>
        <Container>
          <Wrapper>
            <img src={NewsFeedEmptyGorilla} alt="" />
            <InfoContainer>
              <SelectedCircleContainer>
                <IconContainer>
                  {selectedCircle.map((circle) => (
                    <Components.Icon
                      key={circle.id}
                      type="Circle"
                      size="16px"
                      color={circle.colour}
                    />
                  ))}
                </IconContainer>
              </SelectedCircleContainer>
              <NotPostedContainer $gapInPx={8}>
                <Components.Icon
                  type="AlertTriangle"
                  color={Color.icon["icon-brand-bolder"].value}
                  size="16px"
                />
                <Components.Text
                  text={`Your circle${
                    isMultipleCircle ? "s" : ""
                  } has not posted recently.`}
                  style={{ tokenStyle: typography.Heading.S }}
                  lineHeight="line-height-400"
                  color={Color.text["text-emphasize-brand-bolder"].value}
                  fontWeight="font-weight-semibold"
                />
              </NotPostedContainer>
              <NotPostedContainer>
                <Components.Text
                  text={`Add MORE people to your circle${
                    isMultipleCircle ? "s" : ""
                  }?`}
                  style={{ tokenStyle: typography.Body.M }}
                />
                <BackgroundContainer>
                  <Components.Button
                    color="Neutral"
                    kind="Secondary"
                    size="XS"
                    iconPosition="left"
                    iconType="Edit3"
                    disabled={false}
                    label="Manage circle"
                    onClick={() => navigate(ROUTES.manageCircle)}
                    iconColor={Color.icon["icon-inverse"].value}
                  />
                </BackgroundContainer>
              </NotPostedContainer>
            </InfoContainer>
          </Wrapper>
        </Container>
      </BorderContainer>
    </EmptyContainer>
  );
};

export default NewsFeedEmpty;
